import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  taskTemplateKeys,
  RequestTypes,
  taskTemplateMutationKeys,
} from '@core/react-query/features/tasks/templates'
import { ITaskTemplateVersion } from '@core/entities/task/TaskTemplateVersion'

export const useUpdateGlobalTaskTemplateVersionWarning = (
  options?: UseMutationOptions<
    ITaskTemplateVersion,
    RequestErrorType,
    RequestTypes['updateGlobalTaskTemplateVersionWarning']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...taskTemplateMutationKeys.updateGlobalTaskTemplateVersionWarning,
    ...options,
    onSuccess: (_, variables) => {
      const queryKey = taskTemplateKeys.getTaskTemplateVersion({
        templateId: variables.templateId,
        versionId: variables.versionId,
      }).queryKey

      queryClient.invalidateQueries({ queryKey })
    },
  })
}
